// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Number = 1,
  Duration = 2,
  ExistsOperator = 3,
  LogicalOperator = 4,
  InclusionOperator = 5,
  SearchOperator = 6,
  PositionOperator = 7,
  InvalidPositionOperator = 8,
  String = 9,
  IncompleteString = 10,
  FreeText = 11,
  JsonPathIdentifier = 12,
  Filter = 13,
  FilterGroup = 14,
  OpeningBracket = 15,
  FilterStatement = 16,
  FilterKey = 17,
  Identifier = 18,
  InvalidIdentifier = 19,
  Variable = 20,
  JsonPath = 21,
  JsonPathBase = 22,
  JsonPathSeparator = 23,
  JsonPathArray = 24,
  JsonPathNameSelector = 25,
  JsonPathSquareOpeningBracket = 26,
  ComparisonOperator = 27,
  InvalidComparisonOperator = 28,
  FilterSimpleValue = 29,
  Boolean = 30,
  FilterIncludesValue = 31,
  List = 32,
  ClosingBracket = 33,
  ListValue = 34,
  InvalidInclusionValue = 35;
